import React from "react";
import Role from "./Role";
import Permission from "./Permission";
import { SecureModule } from "./SecureModule";

type SecureComponentProps = {
  children: JSX.Element, 
  roles?: Role[],
  permissions?: Permission[],
};
export const SecureComponent = (props: SecureComponentProps) => {
  return <SecureModule {...props} showBlank={true} />
}; 